<template>
	<div class="Column">
		<div class="ColumnTitle" v-if="title">{{title}}</div>
		<div class="ColumnContainer">
			<slot/>
		</div>
	</div>
</template>

<script>
	import { Component, Vue, Prop } from 'vue-property-decorator';

	@Component({
		components: {},
	})
	export default class Column extends Vue {
		@Prop(String) title;
	}
</script>

<style lang="scss">
	.Column {
		flex-grow: 1;
		flex-shrink: 1;
		flex-basis: 0;

		padding: 1vmin;
		display: flex;
		flex-direction: column;
		flex-wrap: nowrap;
		align-content: stretch;

		& > .ColumnTitle {
			width: 100%;
			box-sizing: border-box;
			color: white;
			border: 3px double white;
			padding: 0.5vmin 1vmin;
			text-align: center;
			margin-bottom: 1vmin;
			flex: 0 1 auto;
		}

		& > .ColumnContainer {
			flex: 1 1 auto;
			flex-basis: 0;
			width: 100%;
			overflow: hidden;
		}
	}

</style>